import { render, staticRenderFns } from "./DefaultProfileForm.vue?vue&type=template&id=6a007901&scoped=true"
import script from "./DefaultProfileForm.vue?vue&type=script&lang=ts"
export * from "./DefaultProfileForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a007901",
  null
  
)

export default component.exports